'use strict';

module.exports = {
    BACKGROUND_IMAGE: 'BACKGROUND_IMAGE',
    LOGO: 'LOGO',
    FAVICON: 'FAVICON'
};